export const DEFAULT_LETTER = 'a';
export const MAX_CHARS = 160;
export const STALE_TIME = 1000 * 60 * 60; // 60 minutes

export const GLOSSARY_QUERY_KEY = {
  TERMS: 'glossaries',
  TERM: 'glossary',
  SEARCH: 'search',
};
